export default __webpack_public_path__ + "static/media/fac-production.180237c8.jpg";